// extracted by mini-css-extract-plugin
module.exports = {"main":"_5DkaADGM","list":"_5D382WOm","is-empty":"_5D3UyARg","full":"_5D3WSPad","empty":"_5DCcTiDp"};